import InputRange from './InputRange.vue'

export default InputRange
